import { getPlatform, isAndroid, isIos } from 'src/utils/platform';
import { useEffect, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { AutoFloatingPanel } from 'src/designSystem/AutoFloatingPanel';
import Button from 'src/designSystem/Button';
import PanelHeader from 'src/designSystem/PanelHeader';
import { APP_STORE_LINK, PLAY_STORE_LINK } from 'src/config/externalLinks';
import { logAnalyticsEvent } from 'src/modules/analytics/analytics';
import { getAppVersion } from 'src/modules/appVersion';
import { openExternalUrl } from 'src/utils/openExternalUrl';

type Props = { open: boolean };

const ShouldUpdateNativeAppPanel: FunctionComponent<Props> = ({ open }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;
    logAnalyticsEvent('native_update_required_viewed', {
      platform: getPlatform(),
      // Deliberately getAppVersion(), not input.currentVersion.
      fromVersion: getAppVersion(),
    });
  }, [open]);

  return (
    <AutoFloatingPanel isOpen={open} closable={false}>
      <PanelHeader
        illustration={<div className={'text-4xl text-center'}>🚀</div>}
        title={t('updater.panel.title')}
        description={t('updater.panel.description')}
      />
      <UpdateNativeAppButton />
    </AutoFloatingPanel>
  );
};

const UpdateNativeAppButton = () => {
  const { t } = useTranslation();

  if (isIos()) {
    return (
      <Button
        className={'w-full'}
        type={'primary'}
        data-testid={'btn-update'}
        onClick={() => {
          openExternalUrl(APP_STORE_LINK);
        }}
      >
        {t('updater.panel.update')}
      </Button>
    );
  }

  if (isAndroid()) {
    return (
      <Button
        className={'w-full'}
        type={'primary'}
        data-testid={'btn-update'}
        onClick={() => {
          openExternalUrl(PLAY_STORE_LINK);
        }}
      >
        {t('updater.panel.update')}
      </Button>
    );
  }

  return null;
};

export default ShouldUpdateNativeAppPanel;
